export const PAGES = [{ title: "dashboard", url: "/" }];
